module.exports = __webpack_public_path__ + "img/apollinaire.a510fbde.jpg";